const IS_BROWSER = process.env.JUPITER_TARGET === 'browser';
const MOUNT_ID = 'root';
const ROUTER_BASE_NAME= '';
const getRouterBaseName = null


import { createApp, bootstrap } from  '@jupiter/plugin-runtime';
import { router, state, immer} from "@jupiter/plugin-runtime/plugins";

import React from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import App from '@_jupiter_builtin/main/routes.js';
import { ThemeProvider } from '@jupiter/plugin-runtime/styled';

let AppWrapper = null;

const renderApp = () => {
  if (!window.__GARFISH__ || !Object.keys(window?.Garfish?.appInfos || []).length) {
          
  AppWrapper = createApp({
		plugins: [
		router({basename: ROUTER_BASE_NAME, getRouterBaseName, routesConfig: App.__routes, ...{...undefined,  ...App?.config?.features?.router}, }),
		state({...{
          models: App?.models,
          plugins: [immer]
        }, ...{"promiseConfig":{"disableThrowErrorWhenEffectRejected":true}}, ...App?.config?.features?.state,}),
	],
})(App);
    
  bootstrap(AppWrapper, MOUNT_ID)
  
        }
};

renderApp();




let ModuleApp = null;

export function provider({ basename, dom, ...props }) {
  return {
    render({ basename, dom }) {
      bootstrap(
        createApp({
		plugins: [
		router({ basename, getRouterBaseName, routesConfig: App.__routes, ...{...undefined,  ...App?.config?.features?.router}, }),
		state({...{
          models: App?.models,
          plugins: [immer]
        }, ...{"promiseConfig":{"disableThrowErrorWhenEffectRejected":true}}, ...App?.config?.features?.state,}),
	],
})(
            (appProps) => <App {...{...appProps, ...props, basename}} />
        ),
      dom.querySelector('#' + MOUNT_ID),
      );
    },
    destroy({ dom }) {
      dom = dom && dom.querySelector('#' + MOUNT_ID);
      if (dom) {
        unmountComponentAtNode(dom);
      }
    },
    

  };
}



